import React from 'react';
import CTA from '../../../../components/cta/CTA';
import NavBar from '../../../../components/navbar/navbar';
import Footer from '../../../../components/footer/footer';
import { useNavigate } from 'react-router-dom';

function AboutPage() {

  const navigate = useNavigate()

  return (
    <>
      <NavBar />

      <div className='bg-[#fafafa]'>
        <div className="xl:min-h-screen relative">
          <div className='bg-white absolute -z-0 w-[100%] h-[90%] md:h-[70%]'>
          </div>
          <div className='flex flex-col items-center gap-2 md:gap-4 py-8 md:py-16 px-4 sm:px-8 lg:px-16 relative z-10'>
            <h1 className="text-2xl font-pop text-[#868686] lg:text-3xl font-normal my-4 text-center">About Us</h1>
            <h1 className='text-4xl md:text-5xl font-pop font-semibold text-center'><span className='italic text-primarygreen'>Paycott </span>Company</h1>
            <p className='text-center font-pop text-base max-w-[100%] md:max-w-[80%] xl:max-w-[60%] md:m-auto my-4'>Founded in 2024 in the vibrant heart of Dubai, United Arab Emirates, it was born from a simple yet profound idea: to revolutionize the way people interact and transact digitally.</p>
            <button
              className='bg-primarygreen text-white font-pop rounded-full my-6 py-3 px-8 border-2 border-primarygreen text-lg hover:bg-transparent hover:text-primarygreen ease-in-out duration-300'
              onClick={() => {
                navigate('/signup')
              }}
            >
              Get Started
            </button>
          </div>
          <img src="./Assets/Banner/About.png" alt="" className='m-auto w-[105%] md:w-[90%]  xl:w-[80%] my-8 relative z-10' />
        </div>
        <div className="m-auto w-[90%] xl:w-[80%] py-10">
          <div className="flex flex-col lg:flex-row gap-8">
            <div className="basis-[50%] bg-white rounded-xl py-6 px-6 flex flex-col gap-6">
              <h2 className='font-pop text-xl text-black font-bold'>We had a problem</h2>
              <p className='font-pop text-sm'>In 2023, the seeds of Paycott were sown in the wake of a troubling incident that left one of our CEOs reeling from an online scam. Twice in a single day, he fell victim to fraudulent transactions—once through his bank account and another via Bitcoin. To add insult to injury, the perpetrators promptly blocked him on every platform, from Facebook to WhatsApp to Telegram, leaving him not only out of pocket but also isolated and frustrated.  But from the ashes of this deceit emerged a spark of inspiration. What if there was a marketplace where individuals could create and exchange offers securely, free from the looming threat of deception? Thus, Paycott was conceived—a beacon of trust and reliability in the often murky waters of online transactions. </p>
            </div>
            <div className="basis-[50%] bg-white rounded-xl py-6 px-6 flex flex-col gap-6">
              <h2 className='font-pop text-xl text-black font-bold'>We found solutions</h2>
              <p className='font-pop text-sm'>With unwavering determination, we poured our hearts and souls into crafting an application that would serve as both a shield against fraud and a gateway to seamless, hassle-free transactions.  From its humble beginnings, Paycott has evolved into a symbol of empowerment for millions worldwide. Our commitment to innovation and excellence knows no bounds. We continually strive to enhance and refine our platform, leveraging cutting-edge technology to stay one step ahead of emerging threats and challenges.  But perhaps our greatest success lies not in the accolades or milestones we've achieved, but in the stories of individuals whose lives have been transformed by the security and peace of mind that Paycott provides. Whether it's a small business owner conducting their first online sale or a seasoned investor navigating the complexities of digital currency, Paycott is there every step of the way, empowering dreams and fostering prosperity. </p>
            </div>
          </div>
        </div>
        <CTA />
      </div>

      <Footer />

    </>
  );
}

export default AboutPage;
